import './header.scss';

import AOS from 'aos';
export default async () => {
	// Menu
	$( '.header__menu-list li ul' ).parent( 'li' ).addClass( 'has-children' );
	$( '.header__menu-list > .has-children > a' ).append().after( '<span class=\'header__mm-arrow js-toggle-arrow\'><i class=\'icon-chevron-down\'></i></span>' );
	$( '.js-toggle-arrow' ).click( function ( e ) {
		e.preventDefault();
		let $this = $( this );

		if ( $this.hasClass( 'is-active' ) ) {
			$this.removeClass( 'is-active' );
			$this.next().slideUp( 350 );
		} else {
			$this.parent().parent().find( '.js-toggle-arrow' ).removeClass( 'is-active' );
			$this.parent().parent().find( '.ul' ).slideUp( 350 );
			$this.toggleClass( 'is-active' );
			$this.next().slideToggle( 350 );
		}
	} );


	let $jsToggleMenu = $( '.js-toggle-menu' );

	$jsToggleMenu.click( function ( e ) {
		e.preventDefault();
		$( '.header__menu' ).toggleClass( 'header__menu--open' );
		$( 'body' ).toggleClass( 'is-menu-open' );
	} );

	window.addEventListener( 'scroll', () => {
		if ( window.scrollY > 110 ) {
			document.querySelector( '.header' ).classList.add( 'header--sticky' );
		} else {
			document.querySelector( '.header' ).classList.remove( 'header--sticky' );
		}
	} );
	AOS.init( {
		once: true,
		duration: 1000,
		offset: 100,
	} );
	let scrollRef = 0;

	window.addEventListener( 'scroll', function () {
		scrollRef <= 10 ? scrollRef++ : AOS.refresh();
	} );

	$( '.gfield--type-text .ginput_container > *, .gfield--type-email .ginput_container > *, .gfield--type-textarea .ginput_container > *' ).on( 'focus change input', function (  ) {
		$( this ).closest( '.gfield' ).addClass( 'is-active' );
		if ( $( this ).val().length ) {
			$( this ).closest( '.gfield' ).addClass( 'is-filled' );
		} else {
			$( this ).closest( '.gfield' ).removeClass( 'is-filled' );
		}
	} );

	$( document ).click( function ( e ) {
		if ( !$( e.target ).closest( 'form' ).length ) {
			$( '.gfield' ).not( '.is-filled' ).removeClass( 'is-active' );
		}
	} );

	// Update padding on window resize
	const updateWrapperPadding = () => {
		const header = document.querySelector( '.header' );
		const wrapper = document.querySelector( '.wrapper' );

		if ( header && wrapper ) {
			const headerHeight = header.offsetHeight;

			wrapper.style.paddingTop = `${headerHeight}px`;
		}
	};

	// Ensure the DOM and styles are fully loaded before calculating
	window.addEventListener( 'load', () => {
		updateWrapperPadding();

		// Update padding on window resize
		window.addEventListener( 'resize', updateWrapperPadding );
	} );
};
